module.exports = __webpack_public_path__ + "img/step1.6f4d1ec6.png";